import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded, getFirebase } from 'react-redux-firebase';
import { push } from 'react-router-redux';

import './JobList.css';

import Select from 'react-select';
import { toast } from 'react-toastify';
import LoadingSpinner from 'components/global/LoadingSpinner/LoadingSpinner';
import FormField from '../../contentform/FormField/FormField';

class JobList extends React.Component {
  static propTypes = {
    search: PropTypes.string,
    jobs: PropTypes.object
  };

  state = {
    toggleShowDisabled: false,
    queryText: '',
    queryCompany: '',
    queryType: '',
    queryDepartment: '',
    queryCountry: '',
    sort: null
  };

  databaseToast;

  componentDidMount() {
    if (this.props.search) {
      const pairs = this.props.search.slice(1)
        .split('&');
      let searches = {};
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[`query${temp[0][0].toUpperCase()}${temp[0].slice(1)}`] = temp[1];
      });
      this.setState({ ...searches });
    } else {
      this.setState({
        queryCompany: '',
        queryType: '',
        queryDepartment: '',
        queryCountry: ''
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search) {
      const pairs = nextProps.search.slice(1)
        .split('&');
      let searches = {};
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[`query${temp[0][0].toUpperCase()}${temp[0].slice(1)}`] = temp[1];
      });
      this.setState({ ...searches });
    } else {
      this.setState({
        queryCompany: '',
        queryType: '',
        queryDepartment: '',
        queryCountry: ''
      });
    }
  }

  handleDisabledToggle = () => {
    this.setState({ toggleShowDisabled: !this.state.toggleShowDisabled });
  }

  handleToggleSortCompany = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'company-up' });
        break;
      case 'company-up':
        this.setState({ sort: 'company-down' });
        break;
      case 'company-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'company-up' });
        break;
    }
  }

  handleToggleSortTitle = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'title-up' });
        break;
      case 'title-up':
        this.setState({ sort: 'title-down' });
        break;
      case 'title-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'title-up' });
        break;
    }
  }

  handleToggleSortType = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'type-up' });
        break;
      case 'type-up':
        this.setState({ sort: 'type-down' });
        break;
      case 'type-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'type-up' });
        break;
    }
  }

  handleToggleSortDepartment = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'department-up' });
        break;
      case 'department-up':
        this.setState({ sort: 'department-down' });
        break;
      case 'department-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'department-up' });
        break;
    }
  }

  handleToggleSortCountry = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'country-up' });
        break;
      case 'country-up':
        this.setState({ sort: 'country-down' });
        break;
      case 'country-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'country-up' });
        break;
    }
  }
  
  handleToggleSortStatus = () => {
    switch (this.state.sort) {
      case null:
        this.setState({ sort: 'status-up' });
        break;
      case 'status-up':
        this.setState({ sort: 'status-down' });
        break;
      case 'status-down':
        this.setState({ sort: null });
        break;
      default:
        this.setState({ sort: 'status-up' });
        break;
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value });
  }

  handleSelectCompany = (option) => {
    let searches = {};
    if (this.props.search) {
      const pairs = this.props.search.slice(1)
        .split('&');
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[temp[0]] = temp[1];
      });
      this.setState({ ...searches });
    }
    searches = { ...searches, company: option ? option.value : '' };
    let searchString = '?';
    Object.keys(searches)
      .forEach((key, index) => {
        if (index > 0) {
          searchString = searchString + '&';
        }
        searchString = searchString + key + '=' + searches[key];
      });
    this.props.dispatch(push({
      search: searchString
    }));
  }

  handleSelectType = (option) => {
    let searches = {};
    if (this.props.search) {
      const pairs = this.props.search.slice(1)
        .split('&');
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[temp[0]] = temp[1];
      });
      this.setState({ ...searches });
    }
    searches = { ...searches, type: option ? option.value : '' };
    let searchString = '?';
    Object.keys(searches)
      .forEach((key, index) => {
        if (index > 0) {
          searchString = searchString + '&';
        }
        searchString = searchString + key + '=' + searches[key];
      });
    this.props.dispatch(push({
      search: searchString
    }));
  }

  handleSelectDepartment = (option) => {
    let searches = {};
    if (this.props.search) {
      const pairs = this.props.search.slice(1)
        .split('&');
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[temp[0]] = temp[1];
      });
      this.setState({ ...searches });
    }
    searches = { ...searches, department: option ? option.value : '' };
    let searchString = '?';
    Object.keys(searches)
      .forEach((key, index) => {
        if (index > 0) {
          searchString = searchString + '&';
        }
        searchString = searchString + key + '=' + searches[key];
      });
    this.props.dispatch(push({
      search: searchString
    }));
  }

  handleSelectCountry = (option) => {
    let searches = {};
    if (this.props.search) {
      const pairs = this.props.search.slice(1)
        .split('&');
      pairs.forEach((pair) => {
        const temp = pair.split('=');
        searches[temp[0]] = temp[1];
      });
      this.setState({ ...searches });
    }
    searches = { ...searches, country: option ? option.value : '' };
    let searchString = '?';
    Object.keys(searches)
      .forEach((key, index) => {
        if (index > 0) {
          searchString = searchString + '&';
        }
        searchString = searchString + key + '=' + searches[key];
      });
    this.props.dispatch(push({
      search: searchString
    }));
  }

  handleResetFilters = () => {
    this.setState({ 
      toggleShowDisabled: false,
      queryText: '',
      sortCompany: null,
      sortTitle: null,
      sortType: null,
      sortDepartment: null,
      sortCountry: null,
      sortStatus: null
    });
    this.props.dispatch(push({
      search: ''
    }));
  }

  handleUpdateAllTags = () => {
    const firebase = getFirebase();
    const promises = [];
    const jobsRef = firebase.database()
      .ref(`/job`);
    jobsRef.once('value')
      .then((snapshot) => {
        const jobList = snapshot.val();
        const jobs = Object.keys(this.props.jobs)
          .map(jobKey => jobList[jobKey]);
        jobs.forEach(job => {
          const indexRef = `/jobIndex/${job.company}:${job.code}`;
          const tagDepartmentIndexRef = `/tagJobDepartmentIndex/${job.department}`;
          const tagCountryIndexRef = `/tagJobCountryIndex/${job.country}`;
          promises.push(
            this.props.firebase.update(indexRef, {
              status: job.status,
              code: job.code,
              company: job.company,
              title: job.title,
              type: job.type,
              department: job.department,
              country: job.country
            })
            .then(() => console.log(`[DEBUG] Successfully updated ${job.company}:${job.code}`)),
            this.props.firebase.set(tagDepartmentIndexRef, true),
            this.props.firebase.set(tagCountryIndexRef, true)
          );
        });
        this.databaseToast = toast.info('Saving...');
        return Promise.all(promises);
      })
      .then(() => {
        this.setState({ _isBusy: false });
        toast.update(
          this.databaseToast, {
            render: 'Save success!',
            type: toast.TYPE.SUCCESS,
            autoClose: 3000,
            className: 'JobForm-toast-transition'
          }
        );
      })
      .catch((error) => {
        this.setState({ _isBusy: false });
        toast.update(
          this.databaseToast, {
            render: `Error: ${error.message}`,
            type: toast.TYPE.SUCCESS,
            autoClose: 3000,
            className: 'JobForm-toast-transition'
          }
        );
      });
  }

  handleNavigateJob = (code) => {
    this.props.dispatch(push(`/jobform?job=${code}`));
  }

  _renderJobType = (jobType) => {
    switch (jobType) {
      case 'contract':
        return 'Contract';
      case 'internship':
        return 'Internship';
      case 'parttime':
        return 'Part-Time';
      case 'fulltime':
        return 'Full-Time';
      default:
        return 'ERROR';
    }
  }

  render() {
    const { jobs, companies, typeIndex, departmentIndex, countryIndex } = this.props;
    const {
      toggleShowDisabled,
      queryText,
      queryCompany,
      queryType,
      queryDepartment,
      queryCountry,
      sort
    } = this.state;

    const filteredJobs = [];
    if (jobs) {
      Object.keys(jobs)
        .forEach((jobKey) => {
          if (
            (toggleShowDisabled || jobs[jobKey].status !== 'disabled') &&
            (!queryCompany || jobs[jobKey].company === queryCompany) &&
            (!queryType || jobs[jobKey].type === queryType) &&
            (!queryDepartment || jobs[jobKey].department === queryDepartment) &&
            (!queryCountry || jobs[jobKey].country === queryCountry) &&
            (!queryText || jobs[jobKey].title.toLowerCase()
              .indexOf(queryText.toLowerCase()) !== -1)
          ) {
            filteredJobs.push(jobs[jobKey]);
          }
        });
    }
    if (sort) {
      const temp = sort.split('-');
      const dimension = temp[0];
      const direction = temp[1];
      filteredJobs.sort((a, b) => {
        const textA = a[dimension].toLowerCase();
        const textB = b[dimension].toLowerCase();
        if (direction === 'up') {
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        } else {
          return (textB < textA) ? -1 : (textB > textA) ? 1 : 0;
        }
      });
    }

    return (
      <div className='JobList-root'>
        {
          !isLoaded(jobs) || !isLoaded(companies) || !isLoaded(typeIndex) || !isLoaded(departmentIndex) || !isLoaded(countryIndex) ? 
          <div className='JobList-loadingContainer'>
            <LoadingSpinner />
          </div> :
          <ul className='JobList-list'>
            {/* <button
              className='JobForm-submitButton'
              type='button'
              onClick={this.handleUpdateAllTags}
            >
              UPDATE ALL TAGS
            </button> */}
            <div className='JobList-buttonContainer'>
              <div className='JobList-disabledToggle'>
                <FormField
                  type='checkbox'
                  name='toggleShowDisabled'
                  value={this.state.toggleShowDisabled}
                  onToggle={this.handleDisabledToggle}
                />
                <p>Show Disabled</p>
              </div>
              <button className='JobList-removeButton' type='button' onClick={this.handleResetFilters}>
                <i className='fa fa-trash' />
                {' '}Reset Filters
              </button>
            </div>
            <div className='JobList-searchbar'>
              <div className='JobList-searchbar-left'>
                <input
                  type='text'
                  name='queryText'
                  placeholder='JOB TITLE'
                  value={this.state.queryText}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className='JobList-searchbar-right'>
                <Select
                  name='company'
                  clearable={false}
                  placeholder='COMPANY'
                  value={this.state.queryCompany}
                  onChange={this.handleSelectCompany}
                  options={Object.keys(companies).map(companyKey => ({ value: companyKey, label: companies[companyKey].name }))}
                />
                <Select
                  name='type'
                  clearable={false}
                  placeholder='TYPE'
                  value={this.state.queryType}
                  onChange={this.handleSelectType}
                  options={typeIndex.map(type => ({ value: type.key, label: this._renderJobType(type.key) }))}
                />
                <Select
                  name='department'
                  clearable={false}
                  placeholder='DEPARTMENT'
                  value={this.state.queryDepartment}
                  onChange={this.handleSelectDepartment}
                  options={departmentIndex.map(department => ({ value: department.key, label: department.key }))}
                />
                <Select
                  name='country'
                  clearable={false}
                  placeholder='COUNTRY'
                  value={this.state.queryCountry}
                  onChange={this.handleSelectCountry}
                  options={countryIndex.map(country => ({ value: country.key, label: country.key }))}
                />
              </div>
            </div>
            {
              companies ?
              <table className='JobList-list' cellPadding='0' cellSpacing='0'>
                <colgroup>
                  <col className='col-company' />
                  <col className='col-title' />
                  <col className='col-type' />
                  <col className='col-industry' />
                  <col className='col-country' />
                  <col className='col-status' />
                </colgroup>
                <thead>
                  <tr>
                    <th className='col-company' onClick={this.handleToggleSortCompany}>
                      Company {'  '}
                      { sort === 'company-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'company-down' && <i className='fa fa-caret-down' /> }
                    </th>
                    <th className='col-title' onClick={this.handleToggleSortTitle}>
                      Title {'  '}
                      { sort === 'title-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'title-down' && <i className='fa fa-caret-down' /> }
                    </th>
                    <th className='col-type' onClick={this.handleToggleSortType}>
                      Type {'  '}
                      { sort === 'type-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'type-down' && <i className='fa fa-caret-down' /> }
                    </th>
                    <th className='col-department' onClick={this.handleToggleSortDepartment}>
                      Department {'  '}
                      { sort === 'department-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'department-down' && <i className='fa fa-caret-down' /> }
                    </th>
                    <th className='col-country' onClick={this.handleToggleSortCountry}>
                      Country {'  '}
                      { sort === 'country-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'country-down' && <i className='fa fa-caret-down' /> }
                    </th>
                    <th className='col-status' onClick={this.handleToggleSortStatus}>
                      Status {'  '}
                      { sort === 'status-up' && <i className='fa fa-caret-up' /> }
                      { sort === 'status-down' && <i className='fa fa-caret-down' /> }
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr onClick={() => this.handleNavigateJob('new')}>
                    <td className='col-company' valign='top'>New Job</td>
                    <td className='col-title' valign='top'>Click here to create a new listing</td>
                    <td className='col-type' valign='top'>-</td>
                    <td className='col-department' valign='top'>-</td>
                    <td className='col-country' valign='top'>-</td>
                    <td className='col-status' valign='top'>New</td>
                  </tr>
                  {
                    jobs && filteredJobs.map(job => (
                      <tr key={`${job.company}:${job.code}`} onClick={() => this.handleNavigateJob(`${job.company}:${job.code}`)}>
                        <td className='col-company' valign='top'>{companies[job.company] ? companies[job.company].name : 'Unknown Company'}</td>
                        <td className='col-title' valign='top'>{job.title}</td>
                        <td className='col-type' valign='top'>{this._renderJobType(job.type)}</td>
                        <td className='col-department' valign='top'>{job.department}</td>
                        <td className='col-country' valign='top'>{job.country}</td>
                        <td className='col-status' valign='top'>{job.status ? (job.status[0].toUpperCase() + job.status.slice(1)) : 'Unknown'}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table> : null
            }
          </ul>
        }
      </div>
    );
  }
}

const connectedJobList = connect(
  (state, props) => ({
    jobs: state.firebase.data.jobIndex,
    companies: state.firebase.data.companyIndex,
    typeIndex: state.firebase.ordered.tagJobTypeIndex,
    departmentIndex: state.firebase.ordered.tagJobDepartmentIndex,
    countryIndex: state.firebase.ordered.tagJobCountryIndex
  })
)(JobList);

const wrappedJobList = firebaseConnect([
  { path: '/jobIndex' },
  { path: '/companyIndex' },
  { path: '/tagJobTypeIndex' },
  { path: '/tagJobDepartmentIndex' },
  { path: '/tagJobCountryIndex' }
])(connectedJobList);

export default wrappedJobList;



// WEBPACK FOOTER //
// ./src/components/jobs/JobList/JobList.js